<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice slider">
        <div
          class="fakeoverlay"
          :class="{disabled: !sliderStatus}"
          @click="sliderStatus =! sliderStatus"
        />
        <el-slider
          v-model="value"
          :min="min"
          :step="step"
          :max="max"
          :class="{disabled : !sliderStatus}"
          :disabled="!sliderStatus"
          @change="changeOptionCSS"
        />
      </div>
      <el-checkbox
        v-model="sliderStatus"
        class="control__checkbox"
        @change="changeOptionCSS"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'SliderCSS',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: [Number, String],
      default: 0
    },
    hint: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean
    },
    integer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: +this.default,
      sliderStatus: this.status,
      showHint: false
    }
  },
  computed: {
    ...mapState(['clearOptionsCSS'])
  },
  watch: {
    clearOptionsCSS (val) {
      if (val) {
        this.sliderStatus = false
      }
    },
    eventClick (val) {
      this.sliderStatus = val
      this.value = +this.default
    },
    sliderStatus (val) {
      if (val === true) {
        this.changeOptionCSS()
      }
    }
  },
  methods: {
    changeOptionCSS () {

      let currentValue = ''

      if (this.sliderStatus === true && this.integer === false) {
        currentValue = parseFloat(this.value / 100).toFixed(2)
      }

      if (this.sliderStatus === true && this.integer === true) {
        currentValue = `${parseInt(this.value)}px`
      }

      this.$emit('changeOptionCSS', {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ':',
        value: currentValue
      })
    }
  }
}
</script>
